import { DeviceIcon } from "@/shared/components/icons";
import { RobotoIconUnderlineLink } from "@/shared/components/principal";
import { Goto } from "@/shared/navigation/Goto";

interface DeviceIdLabelProps {
  deviceId: string;
}

/**
 * A device ID linked to its device page, led by the device icon: the same
 * look as a principal such as a dataset's Created by.
 *
 * Device IDs are free-form, so this builds the link from the ID rather than
 * parsing a `device:` principal, which rejects a colon and cuts at an `@`.
 */
export function DeviceIdLabel({ deviceId }: DeviceIdLabelProps) {
  return (
    <RobotoIconUnderlineLink
      icon={<DeviceIcon fontSize="small" color="primary" />}
      to={Goto.createDeviceRoute(deviceId)}
    >
      {deviceId}
    </RobotoIconUnderlineLink>
  );
}
